// unlockPrivateStream.js
'use strict';
import toggleDrmNotSupportAlert, {
  INTERVAL_TO_SHOW_NEXT_ALERT,
} from '../action/toggleDrmNotSupportAlert.js';
import setLivestreamPaymentTimer from '../action/setLivestreamPaymentTimer.js';
import openRecommendDiamondPackSelector from '../action/openRecommendDiamondPackSelector.js';
import setPrivateStreamAutoPayment from '../action/setPrivateStreamAutoPayment.js';

import getMeData from '../selector/getMeData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import { getIsDrmRequirementMatched } from '../selector/getDrmKeySystemAndRobustness.js';

import { DrmFeatureName } from '../resource/drmConstants.js';
import {
  PRECHARGE_SECONDS,
  livestreamPaymentVia as livestreamPaymentViaConstant,
  PRESET_SD,
} from '../resource/liveStreamConstants.js';

/**
 * Unlock private stream
 * @kind action
 * @param {string} {streamId} - stream id.
 * @param {boolean} {shouldCheckDrm} - should check drm.
 * @return {Promise} Action promise.
 */
const unlockPrivateStream =
  ({ streamId, shouldCheckDrm }) =>
  async (dispatch, getState) => {
    if (!streamId) return dispatch({ type: '' });

    if (shouldCheckDrm) {
      const checkDrmCapability = (
        await import('../action/checkDrmCapability.js')
      ).default;
      await dispatch(checkDrmCapability({ isEarlyLeave: true }));
      const isMatched = getIsDrmRequirementMatched(
        getState(),
        DrmFeatureName.LIVESTREAM
      );
      const lastNotSupportAlertTimestamp = getMeData(
        getState(),
        'lastNotSupportAlertTimestamp'
      );
      const needOpenNotSupportAlert =
        Date.now() > lastNotSupportAlertTimestamp + INTERVAL_TO_SHOW_NEXT_ALERT;
      if (!isMatched && needOpenNotSupportAlert) {
        return dispatch(
          toggleDrmNotSupportAlert({
            actionName: 'unlockPrivateStream',
            actionPayload: {
              streamId,
              shouldCheckDrm: false,
            },
          })
        );
      }
    }
    const productId = getLiveStreamData(
      getState(),
      [streamId, 'shop'],
      'productId'
    );
    if (productId) {
      return openRecommendDiamondPackSelector({
        productIds: [productId],
        via: 'unlock-livestream',
        recommendProductId: productId,
      });
    }
    const privateLiveStreamStartTimestamp = getLiveStreamData(
      getState(),
      [streamId, 'presets', PRESET_SD],
      'nbf'
    );
    const privateStreamCounterExp = getLiveStreamData(
      getState(),
      [streamId, 'presets', PRESET_SD, 'counter'],
      'exp'
    );
    const paymentTimestamp =
      privateLiveStreamStartTimestamp || privateStreamCounterExp;

    dispatch(setPrivateStreamAutoPayment({ streamId, isEnabled: true }));
    return dispatch(
      setLivestreamPaymentTimer({
        streamId,
        paymentTimestamp: paymentTimestamp - PRECHARGE_SECONDS,
        via: livestreamPaymentViaConstant.CLICK,
      })
    );
  };

export default unlockPrivateStream;
